import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";
import { MASTERCARD_URL } from "@util/constant";

/**
 * Component to render mastercard section on Partners page
 */
const MastercardSection = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="mastercard-section-component">
      <AccordionV2
        testId="mastercard"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader title="Mastercard" className="px-0" />
        }
        arrowClassName="h-auto w-auto -rotate-90 border-none"
        isArrowRight
      >
        <div className="px-6 pb-2 pt-6">
          <p className="font-bold">
            About Mastercard (NYSE: MA),&nbsp;
            <a
              className="text-blue-175 hover:text-gray-750"
              href={MASTERCARD_URL}
              target="_blank"
              rel="noreferrer"
            >
              www.mastercard.com
            </a>
          </p>

          <p>
            Mastercard is a global technology company in the payments industry.
            Our mission is to connect and power an inclusive, digital economy
            that benefits everyone, everywhere by making transactions safe,
            simple, smart and accessible. Using secure data and networks,
            partnerships and passion, our innovations and solutions help
            individuals, financial institutions, governments and businesses
            realize their greatest potential. Our decency quotient, or DQ,
            drives our culture and everything we do inside and outside of our
            company. With connections across more than 210 countries and
            territories, we are building a sustainable world that unlocks
            priceless possibilities for all.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default MastercardSection;
